import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./loginAbastRua.css";
import Imagens from "../../../components/IMAGESCOMPONENT/ImageComponent";
import { PostLoginRequest } from "./HOOK/PostLoginRequest";

export default function LoginAbastRua() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();

    async function handleSubmit(event) {
        event.preventDefault();

        setLoading(true);
        setError("");

        try {
            const response = await PostLoginRequest(
                username,
                password
            );

            if (response.status === 200) {
                localStorage.setItem(
                    "id_vendedor",
                    response.data.data.codrepresentante
                );

                const hoje = new Date().toISOString().split("T")[0];

                localStorage.setItem(
                    "login_data",
                    hoje
                );

                navigate("/abastece");
            }
        } catch (err) {
            console.error(err);

            setError(
                "Usuário ou senha incorretos"
            );
        } finally {
            setLoading(false);
        }
    }

    function formatCpf(value) {
        const cpf = value.replace(/\D/g, "");

        return cpf
            .replace(/^(\d{3})(\d)/, "$1.$2")
            .replace(
                /^(\d{3})\.(\d{3})(\d)/,
                "$1.$2.$3"
            )
            .replace(
                /\.(\d{3})(\d)/,
                ".$1-$2"
            )
            .slice(0, 14);
    }

    return (
        <div className="loginRua-container">

            <div className="loginRua-card">

                <img
                    src={Imagens.Logo}
                    alt="Logo"
                    className="loginRua-logo"
                />

                <h2 className="loginRua-title">
                    Abastecimento
                </h2>

                <form
                    className="loginRua-form"
                    onSubmit={handleSubmit}
                >

                    <div className="loginRua-field">

                        <input
                            className="loginRua-input"
                            type="text"
                            value={username}
                            placeholder="Usuário ou CPF"
                            autoComplete="username"
                            onChange={(e) => {
                                let value = e.target.value;

                                if (/^\d/.test(value)) {
                                    setUsername(
                                        formatCpf(value)
                                    );
                                } else {
                                    setUsername(
                                        value.toUpperCase()
                                    );
                                }
                            }}
                            required
                        />

                    </div>

                    <div className="loginRua-field">

                        <div className="loginRua-passwordWrapper">

                            <input
                                className="loginRua-input loginRua-inputPassword"
                                type={
                                    showPassword
                                        ? "text"
                                        : "password"
                                }
                                value={password}
                                placeholder="Senha"
                                autoComplete="current-password"
                                onChange={(e) =>
                                    setPassword(
                                        e.target.value.toUpperCase()
                                    )
                                }
                                required
                            />

                            <button
                                type="button"
                                className="loginRua-eyeButton"
                                onClick={() =>
                                    setShowPassword(
                                        !showPassword
                                    )
                                }
                                tabIndex={-1}
                            >
                                {showPassword ? (
                                    <FaEyeSlash />
                                ) : (
                                    <FaEye />
                                )}
                            </button>

                        </div>

                    </div>

                    {error && (
                        <div className="loginRua-error">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        className="loginRua-submit"
                        disabled={
                            loading ||
                            !username ||
                            !password
                        }
                    >
                        {loading
                            ? "Entrando..."
                            : "Entrar"}
                    </button>

                </form>

            </div>

        </div>
    );
}